import { appStoreLenses } from 'root/src/client/logic/app/lenses'
// TODO HERE IS ONE OF 2 PLACES WHERE FRONT END DEPENDS ON COGNITO.ADMINGETUSER
const { pathOrTokens } = appStoreLenses
export default pathOrTokens([])
